<div class="hero-information-card">
  <h3 class="hero-information-card__title">{{ title | translate }}</h3>
  <p class="hero-information-card__description">{{ description | translate }}</p>
</div>
